import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useStore } from "vuex";
import { computed, ref, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ColorCard',
    setup(__props) {
        const store = useStore();
        const consumerColors = computed(() => store.getters.getConsumerColors);
        const colorPickerPosition = computed(() => store.getters.getColorPickerPosition);
        const defaultColor = computed(() => store.getters.getDefaultColor);
        const color = ref(defaultColor.value || null);
        const setColorSelected = () => {
            store.dispatch('setColorSelected', color.value);
        };
        watch(color, () => {
            setColorSelected();
        });
        return (_ctx, _cache) => {
            const _component_v_color_picker = _resolveComponent("v-color-picker");
            return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle({ top: `${colorPickerPosition.value?.top}px` || '0px',
                    left: `${colorPickerPosition.value?.left}px` || '0px' }),
                class: "select-content rounded-3 color-card-container position-absolute"
            }, [
                _createVNode(_component_v_color_picker, {
                    rounded: "",
                    modelValue: color.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((color).value = $event)),
                    theme: "dark",
                    "bg-color": "#3b3b3b",
                    "max-width": "300",
                    mode: "rgb",
                    swatches: [[consumerColors.value.primary_color],
                        [consumerColors.value.secondary_color]],
                    "show-swatches": ""
                }, null, 8, ["modelValue", "swatches"])
            ], 4));
        };
    }
});
